import getOffsetRect from "Helpers/getOffsetRect";
import serialize from "Helpers/serialize";
import { handleJSONResponse } from "Helpers/fetchWrapper";
import LazyLoad from "vanilla-lazyload";
// import Choices from "choices.js";

export default function ArticlesPreviews(container) {
  const form = container.querySelector(".js-articles-previews-form");
  let articlesUpdateUrl;
  // const title = container.querySelector(".js-articles-previews-title");
  // const quantity = container.querySelector(".js-articles-previews-quantity");
  const filterSelects = container.querySelectorAll(
    ".js-articles-previews-filter-select"
  );
  const itemsBlock = container.querySelector(".js-articles-previews-list");
  let itemsBlockOffsetTop = getOffsetRect(itemsBlock).top;
  const paginationBlock = container.querySelector(
    ".js-articles-previews-pagination"
  );
  // const typeInputs = container.querySelectorAll(".js-articles-previews-type-button-input");
  // const typeButtons = container.querySelectorAll(".js-articles-previews-type-button");
  // const typeBaseClass = container.getAttribute("data-type-base-class");
  // let selectChoices;

  window.addEventListener("load", () => {
    itemsBlockOffsetTop = getOffsetRect(itemsBlock).top;
  });

  if (form) {
    articlesUpdateUrl = form.action;
    form.addEventListener("submit", e => {
      e.preventDefault();
    });
  } else {
    articlesUpdateUrl = container.getAttribute("data-url");
  }

  for (let i = 0, len = filterSelects.length; i < len; i++) {
    initFilterSelect(filterSelects[i]);
  }

  // for (let i = 0, len = typeInputs.length; i < len; i++) {
  //     initTypeInput(typeInputs[i]);
  // }

  // for (let i = 0, len = typeButtons.length; i < len; i++) {
  //     initLink(typeButtons[i], true);
  // }

  if (paginationBlock) {
    initPagination(paginationBlock);
  }

  // initSelect();

  // initTagsButtons();

  // function initSelect() {
  //     const selectBlock = container.querySelector(".js-articles-previews-select-block");

  //     if (selectBlock) {
  //         const selectBaseClass = selectBlock.getAttribute("data-base-class");
  //         const selectElement = selectBlock.querySelector("select");

  //         selectChoices = new Choices(selectElement, {
  //             searchEnabled: false,
  //             shouldSort: false,
  //             classNames: {
  //                 containerOuter: selectBaseClass + "__container",
  //                 containerInner: selectBaseClass + "__inner",
  //                 list: selectBaseClass + "__list",
  //                 listSingle: selectBaseClass + "__label",
  //                 listDropdown: selectBaseClass + "__dropdown",
  //                 item: selectBaseClass + "__item",
  //                 itemSelectable: "",
  //                 itemChoice: selectBaseClass + "__dropdown-item"
  //             },
  //             callbackOnCreateTemplates: function (template) {
  //                 const classNames = this.config.classNames;
  //                 return {
  //                     dropdown: () => {
  //                         return template(`
  //                             <div class="${classNames.listDropdown} js-select-scroller" aria-expanded="false"></div>
  //                         `);
  //                     }
  //                 };
  //             }
  //         });

  //         const selectDropdownBody = document.createElement("div");
  //         selectDropdownBody.className = selectBaseClass + "__dropdown-body";
  //         const baronScrollerContainer = selectBlock.querySelector(".js-select-scroller");
  //         const baronScroller = baronScrollerContainer.querySelector(".select__list");
  //         const selectScrollTrack = document.createElement("div");
  //         selectScrollTrack.className = selectBaseClass + "__scrolltrack";
  //         const selectScrollBar = document.createElement("div");
  //         selectScrollBar.className = selectBaseClass + "__scrollbar";
  //         selectScrollTrack.appendChild(selectScrollBar);
  //         baronScrollerContainer.appendChild(selectDropdownBody);
  //         selectDropdownBody.appendChild(baronScroller);
  //         baronScrollerContainer.appendChild(selectScrollTrack);

  //         const customScroll = baron({
  //             root: baronScrollerContainer,
  //             cssGuru: true,
  //             scroller: baronScroller,
  //             barOnCls: selectBaseClass + "__dropdown_scrolling",
  //             bar: selectScrollBar,
  //             direction: "v"
  //         });
  //         customScroll.controls({
  //             track: selectScrollTrack
  //         });

  //         selectElement.addEventListener("change", function() {
  //             const formData = new FormData(form);

  //             fetch(url, {
  //                 method: "POST",
  //                 body: formData
  //             }).then(function(response) {
  //                 if (response.ok) {
  //                     return response.json();
  //                 }

  //                 throw new Error("Network response was not ok.");
  //             }).then(function(jsonData) {
  //                 while (itemsBlock.firstChild) {
  //                     itemsBlock.removeChild(itemsBlock.firstChild);
  //                 }

  //                 updateItemsBlock(jsonData.items);

  //                 while (paginationBlock.firstChild) {
  //                     paginationBlock.removeChild(paginationBlock.firstChild);
  //                 }

  //                 updatePaginationBlock(jsonData.pagination);

  //                 if (paginationBlock) {
  //                     initPagination(paginationBlock);
  //                 }

  //                 if (jsonData.title && title) {
  //                     title.innerText = jsonData.title;
  //                 }

  //                 if (jsonData.quantity && quantity) {
  //                     quantity.innerText = jsonData.quantity;
  //                 }
  //             });
  //         });
  //     }
  // }

  // function initTypeInput(input) {
  //     input.addEventListener("change", function() {
  //         const formData = new FormData(form);

  //         fetch(url, {
  //             method: "POST",
  //             body: formData
  //         }).then(function(response) {
  //             if (response.ok) {
  //                 return response.json();
  //             }

  //             throw new Error("Network response was not ok.");
  //         }).then(function(jsonData) {
  //             while (itemsBlock.firstChild) {
  //                 itemsBlock.removeChild(itemsBlock.firstChild);
  //             }

  //             updateItemsBlock(jsonData.items);

  //             while (paginationBlock.firstChild) {
  //                 paginationBlock.removeChild(paginationBlock.firstChild);
  //             }

  //             updatePaginationBlock(jsonData.pagination);

  //             if (paginationBlock) {
  //                 initPagination(paginationBlock);
  //             }

  //             if (jsonData.title && title) {
  //                 title.innerText = jsonData.title;
  //             }

  //             if (jsonData.quantity && quantity) {
  //                 quantity.innerText = jsonData.quantity;
  //             }
  //         });
  //     });
  // }

  // function initTagsButtons() {
  //     const tagsButtons = container.querySelectorAll(".js-articles-previews-tag-button");

  //     for (let i = 0, len = tagsButtons.length; i < len; i++) {
  //         initTagButton(tagsButtons[i]);
  //     }
  // }

  function initPagination(initializingPaginationBlock) {
    const paginationLinks = initializingPaginationBlock.querySelectorAll(
      ".js-pagination-link"
    );

    for (let i = 0, len = paginationLinks.length; i < len; i++) {
      initLink(paginationLinks[i]);
    }
  }

  // function initTagButton(button) {
  //     const value = button.getAttribute("data-value");

  //     button.addEventListener("click", function(e) {
  //         e.preventDefault();

  //         if (selectChoices) {
  //             selectChoices.setValueByChoice(value);

  //             fetch(url).then(function(response) {
  //                 if (response.ok) {
  //                     return response.json();
  //                 }

  //                 throw new Error("Network response was not ok.");
  //             }).then(function(jsonData) {
  //                 while (itemsBlock.firstChild) {
  //                     itemsBlock.removeChild(itemsBlock.firstChild);
  //                 }

  //                 updateItemsBlock(jsonData.items);

  //                 while (paginationBlock.firstChild) {
  //                     paginationBlock.removeChild(paginationBlock.firstChild);
  //                 }

  //                 updatePaginationBlock(jsonData.pagination);

  //                 if (paginationBlock) {
  //                     initPagination(paginationBlock);
  //                 }

  //                 if (jsonData.title && title) {
  //                     title.innerText = jsonData.title;
  //                 }

  //                 if (jsonData.quantity && quantity) {
  //                     quantity.innerText = jsonData.quantity;
  //                 }
  //             });
  //         }
  //     });
  // }

  function initLink(link) {
    const url = link.href || link.getAttribute("data-href");

    link.addEventListener("click", e => {
      e.preventDefault();
      fetchArticlesUpdate(url);
    });
  }

  function initFilterSelect(filterSelect) {
    filterSelect.addEventListener("change", () => {
      const formData = `${serialize(form)}&ajax=Y`;
      const urlData = `${articlesUpdateUrl}?${formData}`;
      fetchArticlesUpdate(urlData);
    });
  }

  function fetchArticlesUpdate(url) {
    fetch(url)
      .then(handleJSONResponse)
      .then(data => {
        while (itemsBlock.firstChild) {
          itemsBlock.removeChild(itemsBlock.firstChild);
        }

        updateItemsBlock(data.items);

        while (paginationBlock.firstChild) {
          paginationBlock.removeChild(paginationBlock.firstChild);
        }

        updatePaginationBlock(data.pagination);

        if (paginationBlock) {
          initPagination(paginationBlock);
        }

        window.scrollTo({
          top: itemsBlockOffsetTop,
          left: 0
        });

        // if (data.title && title) {
        //     title.innerText = data.title;
        // }

        // if (data.quantity && quantity) {
        //     quantity.innerText = data.quantity;
        // }

        // if (isStatic) {
        //     for (let i = 0, len = typeButtons.length; i < len; i++) {
        //         typeButtons[i].classList.remove(typeBaseClass + "_active");
        //     }

        //     link.classList.add(typeBaseClass + "_active");
        // }
      });
  }

  function updateItemsBlock(content) {
    itemsBlock.innerHTML = content;

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: itemsBlock,
      elements_selector: ".js-lazy-img"
    });

    // eslint-disable-next-line no-new
    new LazyLoad({
      container: itemsBlock,
      elements_selector: ".js-lazy-img-webp",
      to_webp: true
    });
  }

  function updatePaginationBlock(content) {
    paginationBlock.innerHTML = content;
  }
}
